import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext, useRef, useCallback, useEffect } from 'react';
import { FCTheme } from '../../../theming/FCTheme.js';
import { usePopper } from 'react-popper';
import { DropdownMenuStyled } from './style.js';
import { DropdownMenuContext } from './DropdownMenuContext.js';
import MenuItem from './MenuItem.js';

var DropdownMenu = function DropdownMenu(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  var _b = useContext(DropdownMenuContext),
      dropdownState = _b.dropdownState,
      dispatch = _b.dispatch;

  var placement = dropdownState.placement;
  var menuRef = useRef(null);
  var theme = useContext(FCTheme);

  var _c = usePopper(dropdownState.buttonEl.current, menuRef.current, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }]
  }),
      styles = _c.styles,
      attributes = _c.attributes; // const isMounted = useRef(true);
  // const [itemToFocus, setItemToFocus] = useState(0);


  var handleClickOutside = useCallback(function (e) {
    var _a, _b, _c, _d;

    var test = e.target.parentNode;

    if ( // Must be some better way to test if the button is being clicked or not
    menuRef.current !== test && ((_a = dropdownState.buttonEl) === null || _a === void 0 ? void 0 : _a.current) !== e.target && ((_b = dropdownState.buttonEl) === null || _b === void 0 ? void 0 : _b.current) !== ((_c = test === null || test === void 0 ? void 0 : test.parentNode) === null || _c === void 0 ? void 0 : _c.parentNode) && ((_d = dropdownState.buttonEl) === null || _d === void 0 ? void 0 : _d.current) !== (test === null || test === void 0 ? void 0 : test.parentNode)) {
      if (menuRef) {
        dispatch({
          type: 'SET_MENU_OPEN',
          payload: false
        });
        setTimeout(function () {
          dispatch({
            type: 'SET_MENU_VISIBLE',
            payload: false
          });
        }, 200);
      }
    }
  }, [dropdownState.buttonEl]);

  var hideMenu = function hideMenu() {
    dispatch({
      type: 'SET_MENU_OPEN',
      payload: false
    });
    setTimeout(function () {
      dispatch({
        type: 'SET_MENU_VISIBLE',
        payload: false
      });
    }, 200);
  };

  var handleButtonKeyDown = function handleButtonKeyDown(e) {
    switch (e.key) {
      case 'ArrowDown':
        if (dropdownState.selectedItemIndex !== dropdownState.menuItems.length - 1 && dropdownState.menuOpen) {
          e.preventDefault();
          dispatch({
            type: 'SET_ACTIVE_DESCENDANT',
            payload: dropdownState.id + "_menuitem_" + (dropdownState.selectedItemIndex + 1)
          });
          dispatch({
            type: 'INCREASE_SELECTED_ITEM_INDEX'
          });
          return;
        }

        return;

      case 'ArrowUp':
        if (dropdownState.selectedItemIndex !== 0 && dropdownState.menuOpen) {
          e.preventDefault();
          dispatch({
            type: 'SET_ACTIVE_DESCENDANT',
            payload: dropdownState.id + "_menuitem_" + (dropdownState.selectedItemIndex - 1)
          });
          dispatch({
            type: 'DECREASE_SELECTED_ITEM_INDEX'
          });
          return;
        } else {
          return;
        }

      case 'Enter':
        e.preventDefault();

        if (dropdownState.menuItems[dropdownState.selectedItemIndex].props.onClick) {
          dropdownState.menuItems[dropdownState.selectedItemIndex].props.onClick();
          hideMenu();
          return;
        }

      case 'Escape':
        dropdownState.buttonEl.current.focus();
        hideMenu();
        return;

      case 'Tab':
        hideMenu();
    }
  };

  var childrenArray = React.Children.toArray(children).filter(function (child) {
    return child;
  });
  var childrenArrayMenuItems = React.Children.toArray(children).filter(function (child) {
    return child.type === MenuItem;
  });
  useEffect(function () {
    menuRef.current.focus();
    dispatch({
      type: 'SET__MENU_REF',
      payload: menuRef
    });
    dispatch({
      type: 'SET_MENU_ITEMS',
      payload: childrenArrayMenuItems
    });
    window.addEventListener('mousedown', handleClickOutside);
    return function () {
      removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  var itemIndex = 0;
  var ariaProps = {
    'aria-activedescendant': dropdownState.activeDescendant
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, dropdownState.menuVisible && /*#__PURE__*/React.createElement(DropdownMenuStyled, __assign({
    "aria-labelledby": dropdownState.id,
    id: dropdownState.id + "-menu",
    role: "menu"
  }, ariaProps, {
    ref: menuRef,
    theme: theme.theme,
    menuOpen: dropdownState.menuOpen,
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      return handleButtonKeyDown(e);
    },
    style: styles.popper
  }, attributes.popper, rest), childrenArray.map(function (child) {
    if (child.type === MenuItem) {
      var menuItem = /*#__PURE__*/React.createElement(MenuItem, __assign({
        key: child.key,
        index: itemIndex
      }, child.props), child.props.children);
      itemIndex += 1;
      return menuItem;
    } else {
      return child;
    }
  })));
};

export { DropdownMenu };